<template lang="html">
  <li
    :class="[{'divider':divider},{'selected': selected},{'disabled':disabled}]"

    class="ms-component ms-dropdown--item"
    @click="closeParent"
  >
    <router-link
      v-if="to"
      :to="to"
      :class="[{'disabled':disabled},{'checked': isShowCheck}]"
      class="ms-dropdown--item-link"
      v-on="$listeners"
    >
      {{ $attrs.disabled }}
      <slot />
    </router-link>

    <a
      v-else
      :class="[{'disabled':disabled},{'checked': isShowCheck}]"
      class="ms-dropdown--item-link flex justify-between"
      v-on="$listeners"
    >
      <div :class="{'w-full': !isShowCheck}"><slot /></div>
      <div
        v-if="isShowCheck"
        :class="{'mi-check': selected, 'icon-check': isShowCheck}"
        v-on="$listeners"
      />
    </a>
  </li>
</template>

<script>
import _color from "../../../components/controls/color";
export default {
  name: "MsDropdownItem",
  inheritAttrs: false,
  props: {
    to: {},
    disabled: {
      default: false,
      type: Boolean,
    },
    divider: {
      default: false,
      type: Boolean,
    },
    selected: {
      default: false,
      type: Boolean,
    },
    isShowCheck: {
      default: true,
      type: Boolean,
    },
  },
  data: () => ({
    hoverx: false,
    msDropDownItem: true,
    color: null,
  }),
  mounted() {
    this.changeColor();
  },
  updated() {
    this.changeColor();
  },
  methods: {
    closeParent() {
      if (this.disabled) return;
      searchParent(this);
      function searchParent(_this) {
        let parent = _this.$parent;
        if (!parent.$el.className) return;
        if (parent.$el.className.indexOf("parent-dropdown") == -1) {
          searchParent(parent);
        } else {
          let [dropdownMenu] = parent.$children.filter((item) => {
            return item.hasOwnProperty("dropdownVisible");
          });
          dropdownMenu.dropdownVisible = parent.msDropdownVisible = false;
        }
      }
    },
    changeColor() {
      let _self = this;
      searchParent(this);
      function searchParent(_this) {
        let parent = _this.$parent;
        if (!parent.$el.className) {
          return;
        }
        if (parent.$el.className.indexOf("parent-dropdown") == -1) {
          searchParent(parent);
        } else {
          _self.color = parent.color;
        }
      }
    },
    giveColor(opacity = 1) {
      return _color.rColor(this.color, opacity);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/controls/msDropDown.scss";
.icon-check {
  width: 20px;
  margin-left: 8px;
}
</style>